"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("./Tooltip.js"));

var _TooltipText = _interopRequireDefault(require("./TooltipText.js"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TooltipWithIcon = function TooltipWithIcon(_ref) {
  var type = _ref.type,
      info = _ref.info,
      iconSize = _ref.iconSize,
      icon = _ref.icon;
  var toolTipData = _TooltipText["default"][type] || info;

  if (toolTipData) {
    return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      info: toolTipData
    }, /*#__PURE__*/_react["default"].createElement(_styled.TooltipIcon, {
      iconSize: iconSize,
      icon: icon
    }));
  }

  return null;
};

var _default = TooltipWithIcon;
exports["default"] = _default;

//# sourceMappingURL=TooltipWithIcon.js.map